
let swiper;
window.addEventListener("load", function () {
  if ($('body').data('device-type') === 'desktop') {
    if ($('body').hasClass('sub-page')) {
      swiper = new Swiper(".main-swiper", {});
    } else {
      swiper = new Swiper(".main-swiper", {
        direction: "vertical",
        slidesPerView: 1,
        effect: 'fade',
        preloadImages: false,
        mousewheel: true,
        allowTouchMove: false,

        lazy: {
          loadPrevNext: false,
          loadOnTransitionStart: false,
        },

        on: {
          init: function () {
            $('#libraryMainsite-t-float_right').add($('.btn-footer-show')).css('visibility', 'hidden');
          },
          slideChange: function () {
            $('#dream-ms-footer').removeClass('active');

            if (this.activeIndex === 0) {
              $('#libraryMainsite-t-float_right').css('visibility', 'hidden');
            } else if (this.activeIndex === this.slides.length - 1) {
              $('#libraryMainsite-t-float_right').add($('.btn-footer-show')).css('visibility', 'visible');
            } else {
              $('.btn-footer-show').css('visibility', 'hidden');
              $('#libraryMainsite-t-float_right').css('visibility', 'visible');
            }
          }
        }
      });
    }
  } else {
    swiper = new Swiper(".main-swiper", {
      direction: "vertical",
      slidesPerView: 1,
      effect: 'fade',
      preloadImages: false,
      mousewheel: false,
      allowTouchMove: false,

      lazy: {
        loadPrevNext: false,
        loadOnTransitionStart: false,
      },

      on: {
        slideChange: function () {
          $('#dream-ms-footer').removeClass('active');

          if (!window._musicTriggered) {
            $('#vxphl-ld-25-a-navigation .btn-music').trigger('click');
            window._musicTriggered = true;
          }

          if (this.activeIndex === this.slides.length - 1) {
            $('.btn-footer-show').css('visibility', 'visible');
          } else {
            $('.btn-footer-show').css('visibility', 'hidden');
          }
        }
      }
    });
  }
});

let allowScrollTrigger = true;
let touchStartY = 0;

window.addEventListener('touchstart', function (e) {
  touchStartY = e.touches[0].clientY;
});

window.addEventListener('touchend', function (e) {
  const touchEndY = e.changedTouches[0].clientY;
  const deltaY = touchStartY - touchEndY;

  const scrollTop = window.scrollY;
  const windowHeight = window.innerHeight;
  const docHeight = document.documentElement.scrollHeight;

  // Vuốt lên → nếu gần cuối trang thì slideNext
  if (deltaY > 30 && Math.abs(docHeight - (scrollTop + windowHeight)) < 5) {
    swiper.slideNext();
  }

  // Vuốt xuống → nếu gần đầu trang thì slidePrev
  else if (deltaY < -30 && scrollTop < 5) {
    swiper.slidePrev();
  }
});